export const FETCH_LIST_COUPONS = 'FETCH_LIST_COUPONS'
export const LOADING_LIST_COUPONS = 'LOADING_LIST_COUPONS'
export const GET_COUPON_DETAIL = 'GET_COUPON_DETAIL'
export const LOADING_COUPON_DETAIL = 'LOADING_COUPON_DETAIL'
export const CLEAR_COUPON_DETAIL = 'CLEAR_COUPON_DETAIL'
